import React from "react";
import { useHistory } from 'react-router-dom';

import MenuButton from './../../components/MenuButton';
import TraxxLogo from './../../resources/EquipTraceLogo2.png';
import { Button, Image } from "semantic-ui-react";

const Error404 = (props) => {
    const routeHistory = useHistory();

    function returnTo() {
        routeHistory.push(`/dashboard`);
    }

    const style = {
        main: {
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column"
        },
        header: {
            width: "100%",
            minHeight: 100,
            backgroundColor: "black",
            display: "flex",
            flexDirection: "row"
        },
        subHeader: {
            color: "white",
            backgroundColor: "#212121",
            width: "100%",
            minHeight: 70,
            fontSize: 25,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            paddingLeft: 25,
            paddingRight: 25
        },
    }
    return (
        <div style={style.main}>
            <header style={style.header}>
                <div style={{width: "50%"}}><Image src={TraxxLogo} style={{width: 180, height: 90}} /></div>
                <div style={{width: "50%", display:"flex", justifyContent:"flex-end"}}></div>
            </header>
            <section style={style.subHeader}>
                <div style={{width: "50%"}}>404 Page Not Found</div>
                <div style={{width: "50%", display:"flex", justifyContent:"flex-end"}}><Button basic inverted size="mini" icon="cancel" onClick={returnTo} /></div>
            </section>
            <section>

            </section>
        </div>
    )
}

export default Error404;